.tab-row {
  scroll-snap-type: x mandatory;
  border-bottom: 1px solid var(--dds-color-border-subtle);

  @media (prefers-reduced-motion: no-preference) {
    scroll-behavior: smooth;
    transition: var(--dds-focus-transition);
  }

  &:focus-visible button {
    outline: none;
  }
}

.tab {
  border: none;
  -webkit-user-select: text;
          user-select: text;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  color: var(--dds-color-text-medium);
  background: var(--dds-color-surface-default);
  border-top-left-radius: var(--dds-border-radius-button);
  border-top-right-radius: var(--dds-border-radius-button);

  @media (prefers-reduced-motion: no-preference) {
    transition:
      box-shadow var(--dds-motion-micro-state),
      border-bottom var(--dds-motion-micro-state),
      color var(--dds-motion-micro-state),
      background-color var(--dds-motion-micro-state),
      var(--dds-focus-transition);
  }

  &:hover&:not(.tab--active) {
    color: var(--dds-color-text-default);
    background-color: var(--dds-color-surface-hover-default);
  }
}

.tab--medium--row {
  padding: var(--dds-spacing-x0-75) var(--dds-spacing-x1);
  gap: var(--dds-spacing-md-icon-text-gap);
}

.tab--small--row {
  padding: var(--dds-spacing-x0-5) var(--dds-spacing-x0-75);
  gap: var(--dds-spacing-sm-icon-text-gap);
}

.tab--medium--column {
  padding: var(--dds-spacing-x0-75) var(--dds-spacing-x1);
  gap: var(--dds-spacing-x0-25);
}

.tab--small--column {
  padding: var(--dds-spacing-x0-5) var(--dds-spacing-x0-75);
}

.tab--row {
  flex-direction: row;
}

.tab--column {
  flex-direction: column;
}

.tab--active {
  color: var(--dds-color-text-default);
  border-color: var(--dds-color-surface-action-selected);
  box-shadow: inset 0px -2px 0px 0px var(--dds-color-surface-action-selected);
  cursor: default;
}
